import { useEffect, useRef, useState } from 'react'
import { useWindowSize } from './useWindowSize'

export const useRefWidth = ({
  defaultWidth,
}: { defaultWidth?: number } = {}) => {
  const ref = useRef<HTMLDivElement | null>(null)
  const [width, setWidth] = useState(defaultWidth)

  const { width: windowWidth } = useWindowSize()

  useEffect(() => {
    const w = ref.current?.getBoundingClientRect()?.width || defaultWidth
    setWidth(w)
  }, [ref, windowWidth, defaultWidth])

  return { ref, width }
}
